"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(require("./index"));



//////////////////
// WEBPACK FOOTER
// /deploy/www/v2/sa/app/emr-webapp/~/ng4-charts/ng4-charts.js
// module id = ../../../../ng4-charts/ng4-charts.js
// module chunks = 5